const urlName = '/bi/v1/statistics'

export default API => ({
    //汇总数据接口
    getSummarizedData({params, data}) {
        return API({url: `${urlName}/getSummarizedData`, params, data});
    },
    // 新增用户/活跃用户
    getUserStatisticsData({params, data}) {
        return API({url: `${urlName}/getUserStatisticsData`, params, data});
    },

    getLearningTimeStatistics({params, data}) {
        return API({url: `${urlName}/getCourseAndUserSchedule`, params, data});
    },

    /**
     *  获取资源统计

     */
    getResourceStatistics({params, data}) {
        return API({url: `${urlName}/getResources`, params, data});
    },

    getTrainSchedule({params, data}) {
        return API({url: `${urlName}/getTrainSchedule`, params, data});
    },

    // 获取训练营证书
    getTrainCertificateData({params, data}) {
        return API({url: `${urlName}/getTrainCertificateData`, params, data});
    },
    // 下拉
    getFindTrainList({params, data}) {
        return API({url: `${urlName}/findTrainListWithExam`, params, data});
    },
    getfindTrainExam({params, data}) {
        return API({url: `${urlName}/findTrainExamPassingRate`, params, data});
    },


//     1.获取实时数据--当前在线人数/当前学习人数/当前考试人数
    getOnlineUserData({params, data}) {
        return API({url: `${urlName}/getOnlineUserData`, params, data});
    },
    // 2.概况数据--【注册总人数】【学习总人数】【在线人数】【学习完成人数】【学
    // 习总时长】【考试总人数】【获证总人数】
    getSummarizedDataPlus({params, data}) {
        return API({url: `${urlName}/getSummarizedDataPlus`, params, data});
    },
    // 3.行业模型--【专业能力指标】【素质类指标】
    getIndustryModels({params, data}) {
        return API({url: `${urlName}/getIndustryModels`, params, data});
    },
    // 4.用户规模--【各省用户数累计】
    getUserCountGroupByProvince({params, data}) {
        return API({url: `${urlName}/getUserCountGroupByProvince`, params, data});
    },
    // 5.省级学习人次数排行/省级考试人次数排行
    getUserStudyOrExamCountList({params, data}) {
        return API({url: `${urlName}/getUserStudyOrExamCountList`, params, data});
    },

})
